import React from "react";
import { Nav } from "@/components/site/Nav";
import { About } from "@/components/site/About";
import { Credibility } from "@/components/site/Credibility";
import { Footer } from "@/components/site/Footer";
import { LINKS } from "@/lib/links";

export default function AboutPage() {
  return (
    <div className="App font-sans bg-paper text-nearblack antialiased">
      <Nav heroVisible={false} />

      <main className="pt-24 md:pt-28" data-testid="about-page">
        {/* Editorial header */}
        <section className="bg-paper pt-12 md:pt-16 pb-4">
          <div className="max-w-[1400px] mx-auto px-6 md:px-10 lg:px-16">
            <p className="eyebrow mb-7">About</p>
            <h1
              className="font-serif text-nearblack leading-[1.04] text-balance max-w-4xl"
              style={{ fontSize: "clamp(2.5rem, 5vw, 4.5rem)", fontWeight: 400 }}
            >
              Meet{" "}
              <em className="italic text-camel">Liz Dirocco</em>.
            </h1>
            <p
              className="mt-7 text-stonegrey max-w-2xl text-[15px] md:text-[16px] leading-[1.85] font-light"
            >
              An educator, a systems thinker, and a lifelong student of the
              long-term work of building wealth.
            </p>
            <div className="mt-10 h-px w-16 bg-camel/60" />
          </div>
        </section>

        {/* About block (reuses existing component) */}
        <About />

        {/* Always-a-Student / Credibility block (reuses existing component) */}
        <Credibility />

        {/* Quiet CTA into a conversation */}
        <section className="bg-paper py-24 md:py-32" data-testid="about-cta">
          <div className="max-w-[1400px] mx-auto px-6 md:px-10 lg:px-16 text-center">
            <p className="eyebrow mb-7">When You&rsquo;re Ready</p>
            <h2
              className="font-serif text-nearblack leading-[1.08] text-balance max-w-3xl mx-auto"
              style={{ fontSize: "clamp(1.85rem, 3.4vw, 2.85rem)", fontWeight: 400 }}
            >
              A conversation is the{" "}
              <em className="italic text-camel">quickest way</em> to see if
              the work is right for you.
            </h2>
            <p className="mt-7 max-w-xl mx-auto text-stonegrey text-[15px] md:text-[16px] leading-[1.85] font-light">
              No pressure. No pitch. Just a relaxed conversation about
              where you are and what you’re trying to build.
            </p>
            <div className="mt-10 flex flex-col sm:flex-row gap-4 justify-center">
              <a
                href={LINKS.calendly}
                target="_blank"
                rel="noopener noreferrer"
                data-testid="about-cta-book"
                className="btn-camel inline-block"
              >
                Book a Conversation
              </a>
              <a
                href="/quiz"
                data-testid="about-cta-quiz"
                className="inline-block text-[11px] tracking-[0.22em] uppercase font-medium text-nearblack hover:text-camel border border-paperdeep px-7 py-3.5 self-center"
              >
                Take the Assessment
              </a>
            </div>
          </div>
        </section>
      </main>

      <Footer />
    </div>
  );
}
